'use client';
import React, { useEffect, useRef, useState } from 'react';
import styles from './FusionHeaderBurger.module.scss';
import classNames from 'classnames';
import { FusionNavigationLink, FusionNavigationLinks } from './FusionNavigationLinks';

interface Props {
  isMobile: boolean;
  headerHeight: number;
  navigationLinks: FusionNavigationLink[];
  burgerMenuLinks: {
    title: string;
    subtitle: string;
    url: string;
  }[];
}

export const FusionHeaderBurger = ({ burgerMenuLinks, headerHeight, isMobile, navigationLinks }: Props) => {
  const [visible, setVisible] = useState(false);
  const menuRef = useRef<HTMLDivElement>(null);

  const clickHandler = () => setVisible(prevState => !prevState);

  useEffect(() => {
    const closeHandler = (e: MouseEvent) => {
      if (menuRef.current && !menuRef.current.contains(e.target as HTMLDivElement) && e.target !== menuRef.current)
        setVisible(false);
    };

    if (visible) {
      requestAnimationFrame(() => {
        document.addEventListener('click', closeHandler);
      });
    }
    return () => {
      if (visible) document.removeEventListener('click', closeHandler);
    };
  }, [visible]);

  useEffect(() => {
    if (menuRef.current) {
      if (visible) {
        menuRef.current.style.maxHeight = menuRef.current.scrollHeight + 'px';
      } else {
        menuRef.current.style.maxHeight = '0';
      }
    }
  }, [visible]);

  return (
    <div className={styles.burgerContainer} style={{ '--header-height': `${headerHeight}px` } as React.CSSProperties}>
      <div
        className={classNames('fusion-burger-button', { [`fusion-burger-button-active`]: visible })}
        onClick={clickHandler}
      >
        {!isMobile && <span>Menu</span>}
        <div className="fusion-burger-icon">
          <span />
          <span />
          <span />
        </div>
      </div>
      <div className="fusion-burger-menu-layout">
        <div className="fusion-burger-menu-wrapper" ref={menuRef}>
          <div className="fusion-burger-menu-left-side">
            {Array.isArray(burgerMenuLinks) &&
              burgerMenuLinks.map((link, i) => (
                <a className="menu-link-wrapper" href={link.url} key={i}>
                  <p className="menu-link-title">{link.title}</p>
                  <p className="menu-link-subtitle">{link.subtitle}</p>
                </a>
              ))}
          </div>
          <div className="fusion-burger-menu-right-side">
            <FusionNavigationLinks direction="vertical" linkColor="#283D59;" links={navigationLinks} />
          </div>
        </div>
      </div>
    </div>
  );
};
